import React, { useMemo } from "react";
import Select from "react-select";

const MultiSelectDropdown = ({ placeholder, options, label, values, error, onSelect, disabled, isRequired = true }) => {
  // Format options for react-select
  const formattedOptions = useMemo(() => {
    return options.map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }, [options]);

  // Memoize selected options from values array
  const selectedOptions = useMemo(() => {
    return formattedOptions.filter(opt => values?.some(val => val.name === opt.label)) || [];
  }, [values, formattedOptions]);


  const handleChange = (selected) => {
    if (onSelect) {
      const selectedRaw = selected.map((sel) =>
        options.find((item) => item.name === sel.label)
      );
      onSelect(selectedRaw);
    }
  };

  const handleRemoveSelected = (removedItem) => {
    if (onSelect) {
      const updated = values.filter((item) => item.name !== removedItem.label);
      onSelect(updated);
    }
  };

  return (
    <div className="mb-1 mx-1 search-select" key={options.length}>
      {label && <label className="input-label mb-1">{label} {isRequired ? <span className="text-danger" style={{fontSize: "14px"}}><sup>*</sup></span> : null}</label>}
      <Select
        classNamePrefix="my-select"
        isMulti
        isSearchable
        isDisabled={disabled}
        className={`input-box ${error ? "input-error" : ""}`}
        placeholder={placeholder}
        options={formattedOptions}
        value={selectedOptions}
        onChange={handleChange}
        components={{
            MultiValue: () => null,  // 🚀 Hide selected tags inside the input
          }} />

      {/* Showing Selected Tags Below */}
      <div className="selected-tags mt-2 flex flex-wrap gap-2">
        {selectedOptions.map((item) => (
          <div key={item.value} className="selected-tag" onClick={() => handleRemoveSelected(item)}>
            {item.label} ✕
          </div>
        ))}
      </div>

      {error && <div className="error-message mt-1">{error}</div>}
    </div>
  );
};

export default MultiSelectDropdown;